/** @jsxImportSource @emotion/react */
import { css } from "@emotion/react";
import { CircularProgress } from "@mui/material";
import AppScreen from "components/AppScreen";
import Colors from "util/colors";
import { ReactNode } from "react";

const colors = Colors.get();

const styles = {
  wrapper: css({
    position: "absolute",
    top: 0,
    left: 0,
    display: "flex",
    flexDirection: "column",
    justifyContent: "center",
    alignItems: "center",
    width: "100%",
    height: "100%",
    backgroundColor: colors.background,
  }),

  msg: css({
    fontSize: "1rem",
    marginBottom: "0.5rem",
  }),
};

/**
 * プロパティ定義
 */
type Props = {
  /** ヘッダーの要素 */
  header?: ReactNode;
  /** リセット位置初期化の要否(デフォルトはtrue) */
  resetScroll?: boolean;
};

/**
 * ロード画面
 * @param param コンポーネントのProps
 */
export default function CmnPageLoading({
  header,
  resetScroll = true,
}: Props) {
  return (
    <AppScreen resetScroll={resetScroll}>
      {header}
      <div css={styles.wrapper}>
        <CircularProgress />
      </div>
    </AppScreen>
  );
}
